<template>
    <v-container>
        <h1>Overzichten tokens en consoles</h1>
        <div class="button-bar">
            <a href="#" @click="tokenMode()" class="a-tab" v-bind:class="{selected: mode=='token'}">Overzicht tokens</a>&nbsp;<a href="#" @click="consoleMode()" class="a-tab" v-bind:class="{selected: mode=='console'}">Overzicht consoles</a>
        </div>
        <br/>
        <OverzichtTokens v-show="mode=='token'"></OverzichtTokens>
        <OverzichtConsoles v-show="mode=='console'"></OverzichtConsoles>
    </v-container>
</template>

<script>

// @ is an alias to /src
import OverzichtConsoles from '@/components/OverzichtConsoles.vue'
import OverzichtTokens from '@/components/OverzichtTokens.vue'


export default {
	name: 'BeheerOverzicht',
	components: {
        OverzichtConsoles,
        OverzichtTokens
    },
    data() {
        return {
            mode: "token"
        }
    },
    methods: {
        getClient: function() {
            this.clientnummer = this.zoekclientnummer;
        },
        tokenMode: function() {
            this.mode = "token";
        },
        consoleMode: function() {
            this.mode = "console";
        },
    },
    created: function() {
        
    }
}
</script>

<style>

.clientnummer {
	height: 30px;
	margin-right: 20px;
	font-size: 13pt;
	width: 160px;
	border: 1px solid silver;
	padding-left: 5px;
}

.a-tab {
    border: 2px solid #00B4D1;
    width: 350px;
    height: 28px;
    line-height: 28px;
    margin-right: 5px;
    margin-top: 15px;
    margin-bottom: 5px;
    text-align: center;
    display: inline-block;
    text-decoration: none;
    color: black;
    font-weight: bold;
    font-size: 13pt;
}

.a-tab:hover {
    background-color: #00B4D1;
}

.selected {
    background-color: #00B4D1;
    color: #fff;
}

.caption {
	font-weight: bold;
	font-size: larger;
}
.caption-field {
	margin-top: 10px;
	display: flex;
	line-height: 1.7;
}
</style>